import React from "react";
import { Menubar } from "primereact/menubar";
import { Button } from "primereact/button";
import { useRef } from "react";
import { Menu } from "primereact/menu";
import { getTokenInfo } from "../utils/Guard";
import logoABA from "../Assets/Img/LogoABA.png";
import UserMenu from "./UserMenu";

import "./NavBar.css";

const NavBar = (props) => {

  const menuUser = useRef(null);
  const menuSign = useRef(null);

  const items = [];

  const userItems = [];
  const requestItems = [];

  const userInfo = getTokenInfo();

  const UserActions = {
    label: "Perfil",
    icon: "pi pi-fw pi-users",

    template: () => {
      return (
        <>
          {userItems.length > 0 && (
            <>
              <Menu
                model={userItems}
                popup
                ref={menuUser}
                id="popup_menu_right"
                className="dropdownMenu"
              />
              <Button
                label="Perfil"
                className={`dropdownButton `}
                size="small"
                icon="pi pi-user"
                onClick={(event) => {
                  menuUser.current.toggle(event);
                }}
              />
            </>
          )}
        </>
      );
    },
  };

  

  items.push(UserActions);

  // if (userInfo.Roles !== undefined && userInfo.Roles.includes("user.menu")) {
  //   userItems.push({
  //     template: () => {
  //       return (
  //         <Button
  //           label="Personas"
  //           size="small"
  //           icon="pi pi-users"
  //           onClick={() => {
  //             window.location.href = "/users";
  //           }}
  //           className="dropdownMenu"
  //         />
  //       );
  //     },
  //   });
  // }

  if (userInfo.Roles !== undefined && userInfo.Roles.includes("charge.menu")) {
    userItems.push({
      template: () => {
        return (
          <Button
            label="Cargos"
            size="small"
            icon="pi pi-briefcase"
            onClick={() => {
              window.location.href = "/charges";
            }}
            className="dropdownMenu"
          />
        );
      },
    });
  }

  if (
    userInfo.Roles !== undefined &&
    userInfo.Roles.includes("departments.menu")
  ) {
    userItems.push({
      template: () => {
        return (
          <Button
            label="Departamentos"
            size="small"
            icon="pi pi-building-columns"
            onClick={() => {
              window.location.href = "/departments";
            }}
            className="dropdownMenu"
          />
        );
      },
    });
  }


    userItems.push({
      template: () => {
        return (
          <Button
            label="Cargar Usuarios"
            size="small"
            icon="pi pi-users"
            onClick={() => {
              window.location.href = "/upload-users";
            }}
            className="dropdownMenu"
          />
        );
      },
    });
  


  // if (userInfo.Roles !== undefined && userInfo.Roles.includes("country.menu")) {
  //   userItems.push({
  //     template: () => {
  //       return (
  //         <Button
  //           label="País"
  //           size="small"
  //           icon="pi pi-map-marker"
  //           onClick={() => {
  //             window.location.href = "/country";
  //           }}
  //           className="dropdownMenu"
  //         />
  //       );
  //     },
  //   });
  // }

  if (
    userInfo.Roles !== undefined &&
    userInfo.Roles.includes("organization.menu")
  ) {
    userItems.push({
      template: () => {
        return (
          <Button
            label="Organización"
            size="small"
            icon="pi pi-sitemap"
            onClick={() => {
              window.location.href = "/organization";
            }}
            className="dropdownMenu"
          />
        );
      },
    });
  }

  // if (
  //   userInfo.Roles !== undefined &&
  //   userInfo.Roles.includes("documenttype.menu")
  // ) {
  //   userItems.push({
  //     template: () => {
  //       return (
  //         <Button
  //           label="Tipo de documento"
  //           size="small"
  //           icon="pi pi-file"
  //           onClick={() => {
  //             window.location.href = "/documenttype";
  //           }}
  //           className="dropdownMenu"
  //         />
  //       );
  //     },
  //   });
  // }

  // if (
  //   userInfo.Roles !== undefined &&
  //   userInfo.Roles.includes("permissions.menu")
  // ) {
  //   userItems.push({
  //     template: () => {
  //       return (
  //         <Button
  //           label="Permisos"
  //           size="small"
  //           icon="pi pi-id-card"
  //           onClick={() => {
  //             window.location.href = "/permissions";
  //           }}
  //           className="dropdownMenu"
  //         />
  //       );
  //     },
  //   });
  // }

  const SignActions = {
    label: "Solicitud",
    icon: "pi-directions-alt",

    template: () => {
      return (
        <>
          {requestItems.length > 0 && (
            <>
              <Menu
                model={requestItems}
                popup
                ref={menuSign}
                id="popup_menu_right"
                className="dropdownMenu"
              />
              <Button
                label="Solicitud"
                size="small"
                icon="pi pi-arrow-circle-up"
                onClick={(event) => {
                  menuSign.current.toggle(event);
                }}
                className={`dropdownButton`}
              />
            </>
          )}
        </>
      );
    },
  };

  // if (userInfo.Roles !== undefined && userInfo.Roles.includes("status.menu")) {
  //   requestItems.push({
  //     template: () => {
  //       return (
  //         <Button
  //           label="Estado"
  //           size="small"
  //           icon="pi pi-bullseye"
  //           onClick={() => {
  //             window.location.href = "/status";
  //           }}
  //           className="dropdownMenu"
  //         />
  //       );
  //     },
  //   });
  // }

  if (userInfo.Roles !== undefined && userInfo.Roles.includes("sign.menu")) {

    requestItems.push({
      template: () => {
        return (
          <Button
            label="Certificados Internos"
            size="small"
            icon="pi pi-pencil"
            onClick={() => {
              window.location.href = "/sign";
            }}
            className="dropdownMenu"
          />
        );
      },
    });
  }

  if (userInfo.Roles !== undefined && userInfo.Roles.includes("sign.external")) {
    requestItems.push({
      template: () => {
        return (
          <Button
            label="Certificados Externos"
            size="small"
            icon="pi pi-pencil"
            onClick={() => {
              window.location.href = "/external-signs";
            }}
            className="dropdownMenu"
          />
        );
      },
    });
  }

  items.push(SignActions);

  const start = (
    <>
      <img
        className="NavBarImage"
        alt="logo"
        src={logoABA}
        style={{}}
        onClick={() => {
          window.location.href = "/home";
        }}
      ></img>
    </>
  );
  const   end = (
    <div className="NavBarButtons">
      <UserMenu userName={props.userName} logoutHandler={props.logoutHandler} />
    </div>
  );

  return (
    <>
      <Menubar
        model={items}
        start={start}
        end={end}
        className="NavBar"
        style={{
          marginTop: "0px",
          width: "100%",
          backgroundColor: "#143047",
          border: "#143047",
          borderRadius: "0px",
          borderBottom: "solid #fff",
        }}
      />
    </>
  );
};
export default NavBar;
